export const SETUP_MISSING_COMPANY_INFO = 1;
export const SETUP_CRAWLER_REQUIRED = 2;
export const SETUP_READY_NO_ACTIVE_USER = 4;
export const SETUP_COMPLETE = 5;
